import l from '@/i18n.js'
export function idioma_bartolome(lang) {
    let idiomas = [
        {
            'mewo': 'es',
            'neo': 'SPA'
        }, {
            'mewo': 'gb',
            'neo': 'ENG'
        }
    ]
    let res = idiomas.find(v => {
        return v.mewo == lang
    })
    return (res) ? res.neo : 'SPA';
}

export const codigoNegocioTotem = (s) => {
    return s.substr(0, s.indexOf('-'));
}

export const ordenarArray = (a, b) => (a.orden > b.orden) ? 1 : ((b.orden > a.orden) ? -1 : 0)

export const mostrarIdioma = (s) => {
    let idioma = l.locale;
    if (l.locale == 'gb') idioma = 'en';

    let mostrar = (s && Array.isArray(s)) ? s.find(e => e.lang == idioma) : ''
    return mostrar.text;
}

export const parsePrecios = (data) => {
    // let prod =  state.activeProduct;
    let prod = data;
    var descuento = 1;

    if (prod.id != undefined) {
        if (prod.precioRest == undefined || prod.precioCobrar == 0 && prod.opciones.length > 0) {
            for (let i = 0; i < prod.opciones.length; i++) {
                let precioOpciones = prod.opciones;
                if (precioOpciones[i].opciones != undefined) {
                    let precioBaseArray = (precioOpciones[i]).opciones.map((e) => {
                        return e.precioCobrar != undefined && e.precioCobrar > 0 ? e.precioCobrar : 0;
                    });

                    let sinCeros = precioBaseArray.filter((e) => {
                        return e > 0;
                    });
                    if (sinCeros.length > 0) {
                        prod.precioCorregido = Math.min.apply(Math, sinCeros);
                        (precioOpciones[i]).opciones.forEach((e) => {
                            if (e.precioRest) e.precioCorregido = e.precioCobrar - prod.precioCorregido;
                        })

                        i = prod.opciones.length;
                    }

                } else {
                    prod.precioCorregido = parseFloat(precioOpciones[i].precio);
                }

                // Carga el descuento si esta definido y si el precio no es cero
                if (prod.descuentoPorcentaje) descuento = descuento - parseFloat(prod.descuentoPorcentaje)
                //if (prod.precioCorregido > 0) prod.precioCorregido = prod.precioCorregido * descuento;
            }
        }
    }
    if (prod.id == "1iCMNKJkyaxHoUaN2vmm") console.log(prod);
    return prod;
}

export const mostrarPrecio = (prod, modo) => {
    let precio = 0;
    if (prod.id == "1iCMNKJkyaxHoUaN2vmm") console.log(prod);
    console.log(prod)
    precio = parseFloat(prod.precioRest);
    if (prod.precioCorregido != undefined) {
        precio = parseFloat(prod.precioCorregido);
    } else {
        precio = parseFloat(prod.precioCobrar);
    }

    //precio = parseFloat(precio)
    if (prod.id == "1iCMNKJkyaxHoUaN2vmm") console.log(precio);
    return (precio.toFixed(2));

}

export const pointInPolygon = (point, vs) => {
    var x = point[0], y = point[1];

    var inside = false;
    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i].lat, yi = vs[i].lng;
        var xj = vs[j].lat, yj = vs[j].lng;

        var intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }

    return inside;
}

export const mostrarImpuestoTexto = (codigoImpuesto, impuestos) => {
    let tax = (typeof (codigoImpuesto) == 'string' && Array.isArray(impuestos)) ? impuestos.find(e => e.id == codigoImpuesto) : '';
    let res = tax.nombre.split(" ")[0] + ' (' + tax.nombre.split(" ")[1] + '%)';
    return res;
}

export const mostrarImpuestoPorcentaje = (codigoImpuesto, impuestos) => {
    let res = (typeof (codigoImpuesto) == 'string' && Array.isArray(impuestos)) ? impuestos.find(e => e.id == codigoImpuesto) : ''
    return res.impuesto;
}

export const getCentroGeodesica = (coord1, coord2) => {
    let c = [(coord1[0] + coord2[0]) / 2, (coord1[1] + coord2[1]) / 2]
    return c;
}

export const formatearDireccionGoogle = (data) => {
    let dir = {
        calle: '',
        numero: '',
        adicional: '',
        cp: '',
        municipio: '',
        provincia: '',
        codigoProvincia: '',
        pais: '',
        codigoPais: ''
    };

    data.forEach(function (e) {
        var tipo_aux = e.types[0];
        switch (tipo_aux) {
            case 'street_number':
                dir.numero = e.long_name;
                break;
            case 'route':
                dir.calle = e.long_name;
                break;
            case 'locality':
                dir.municipio = e.long_name;
                break;
            case 'administrative_area_level_2':
                dir.provincia = e.long_name;
                break;
            case 'neighborhood':
                dir.calle = e.long_name;
                break;
            case 'bus_station':
                dir.calle = e.long_name;
                break;
            case 'train_station':
                dir.calle = e.long_name;
                break;
            case 'airport':
                dir.calle = e.long_name;
                break;
            case 'subway_station':
                dir.calle = e.long_name;
                break;
            case 'fire_station':
                dir.calle = e.long_name;
                break;
            case 'hospital':
                dir.calle = e.long_name;
                break;
            case 'museum':
                dir.calle = e.long_name;
                break;
            case 'point_of_interest':
                dir.calle = e.long_name;
                break;
            case 'park':
                dir.calle = e.long_name;
                break;
            case 'establishment':
                dir.calle = e.long_name;
                break;
            case 'transit_station':
                dir.calle = e.long_name;
                break;
            case 'postal_code':
                dir.cp = e.long_name;
                break;
            case 'country':
                dir.pais = e.long_name;
                dir.codigoPais = e.short_name;
                break;
            default:
                break;
        };
    });

    return dir;
}

export const redondeo = (num) => {
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100
}


